import { ForceUpgradeModal } from "@/components/modals/ForceUpgradeModal"
import { useForceUpgrade } from "@/hooks/useForceUpgrade"

/** Mounted once at the root so the gate covers every route. */
export const ForceUpgradeGate = () => {
  const { required, title, message, buttonTitle } = useForceUpgrade()

  return (
    <ForceUpgradeModal
      visible={required}
      title={title}
      message={message}
      buttonTitle={buttonTitle}
    />
  )
}
